export default {
	init() {
		
		const observeIframes = (iframes) => {
            iframes.forEach((iframe) => {
                iframeObserver.observe(iframe)
            })
        }

        const iframeObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('in-view')
                }
            })
        },{
            // Adjust the rootMargin to add offset (e.g., 50px)
            rootMargin: '-100px 0px'
        })

        const mutationObserver = new MutationObserver((mutationsList) => {
            mutationsList.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            if (node.classList.contains('intersection')) {
                                iframeObserver.observe(node)
                            } else {
                                const newIframes = node.querySelectorAll('.intersection')
                                observeIframes(newIframes)
                            }
                        }
                    })
                }
            })
        })

        // Initial observation
        const initialIframes = document.querySelectorAll('.intersection')
        observeIframes(initialIframes)

        // Observe the document body for dynamic additions
        mutationObserver.observe(document.body, {
            childList: true,
            subtree: true
        })
	}
}
